import { Fragment } from 'react';
// Ui
import Text from 'ui3/Text/Text';
import Divider from 'ui3/Divider/Divider';
// Styles
import styles from './SummaryCard.module.scss';

export type SummaryRow = { label: string; value: string | number };

type SummaryCardProps = {
  /** Groups of rows, divided from each other. */
  groups: SummaryRow[][];
};

/** The "SUMMARY" card beside the create wizards' pricing and advanced steps. */
const SummaryCard = ({ groups }: SummaryCardProps): JSX.Element => (
  <aside className={styles.root} aria-label="Summary">
    <Text variant="h6">SUMMARY</Text>
    {groups.map((rows, index) => (
      <Fragment key={rows[0].label}>
        {index > 0 && <Divider />}
        <dl className={styles.rows}>
          {rows.map(({ label, value }) => (
            <div key={label} className={styles.row}>
              <Text as="dt" variant="body2Regular" color="lights-low">
                {label}
              </Text>
              <Text as="dd" variant="body2Medium" className={styles.value}>
                {value}
              </Text>
            </div>
          ))}
        </dl>
      </Fragment>
    ))}
    <Divider />
    <Text variant="captionRegular" color="lights-low">
      Every Participant you invite gets a unique affiliate link automatically.
      Refunded or cancelled purchases don&apos;t count toward earnings.
    </Text>
  </aside>
);

export default SummaryCard;
